import * as React from 'react';
import FormDialog, {SpecificFormDialogProps} from 'cl-dialogs/FormDialog';
import InlineButton from '../../InlineButton';
import {GENERAL_ACTIONS_TYPES} from "../../../ActionsManager/ActionsTypes";
import {ACTION_DISPLAY_TYPES} from "../../../ActionsManager/ActionsManagerConsts";
import GeneralActions from '../../../ActionsManager/GeneralActions/GeneralActions';

interface ReAuthenticateFormData {
  action: () => void;
  sellerId: string;
}

export type ReAuthenticateEbayAccountDialogProps = SpecificFormDialogProps<{}, ReAuthenticateFormData>

export default class ReAuthenticateEbayAccountDialog extends React.PureComponent<ReAuthenticateEbayAccountDialogProps> {

  render() {
    const {action, sellerId, ...props} = this.props;
    return (
      <FormDialog<{}>
        disableExit
        formName={'reAuthenticateEbayAccount'}
        initialValues={{action: this.props.action}}
        title={'ebay authentication required for ' + sellerId}
        text={<React.Fragment>To use <InlineButton target="_blank" href="https://www.ebay.com/help/listings/creating-managing-listings/listing-item-product-details-catalog?id=4653">eBay catalog</InlineButton> products you are required to re-authenticate your eBay account.<br/>
          Clicking the button below will take you to eBay to securely re-authenticate your eBay account.<br/>
          It will take only 20 seconds and you will only be required to do it once per account.</React.Fragment>}
        actions={<GeneralActions
          types={[GENERAL_ACTIONS_TYPES.CONNECT_EBAY_SELLER]}
          displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
          additionalActionData={action}
        />}
        {...props}
      />
    );
  }
}